export default function Process() {
  const steps = [
    {
      number: '01',
      icon: 'fa-clipboard-list',
      title: '상담 및 견적',
      description: '물류 요구사항 분석 후\n맞춤형 견적 제공'
    },
    {
      number: '02',
      icon: 'fa-handshake',
      title: '계약 체결',
      description: '상호 협의 후\n서비스 이용 계약'
    },
    {
      number: '03',
      icon: 'fa-warehouse',
      title: '입고 및 보관',
      description: '상품 입고 후\n체계적인 보관 관리'
    },
    {
      number: '04',
      icon: 'fa-truck',
      title: '출고 및 배송',
      description: '신속 정확한 출고\n안전한 배송 완료'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-cyan-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-cyan-600 font-semibold mb-2 tracking-wider text-sm">PROCESS</p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">간편한 물류 프로세스</h2>
          <p className="text-gray-600 text-lg">4단계로 시작하는 스마트 물류</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center relative z-10">
                <div className="inline-block mb-4">
                  <div className="w-20 h-20 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
                    {step.number}
                  </div>
                </div>
                
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`fas ${step.icon} text-blue-600 text-2xl`}></i>
                </div>
                
                <h4 className="font-bold text-gray-900 mb-3 text-lg">{step.title}</h4>
                <p className="text-gray-600 whitespace-pre-line">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}